import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/Phoenix-Plumbing-Services")({
  beforeLoad: () => {
    throw redirect({
      href: "https://www.phoenixplumbing.co/",
      statusCode: 301,
    });
  },
  component: () => null,
});
